import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var Config = /*#__PURE__*/function (_Component) {
  _inherits(Config, _Component);

  function Config() {
    _classCallCheck(this, Config);

    return _possibleConstructorReturn(this, _getPrototypeOf(Config).apply(this, arguments));
  }

  _createClass(Config, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          baseUrl = _this$props.baseUrl,
          clientId = _this$props.clientId,
          marketId = _this$props.marketId,
          countryCode = _this$props.countryCode,
          languageCode = _this$props.languageCode,
          cartUrl = _this$props.cartUrl,
          returnUrl = _this$props.returnUrl,
          privacyUrl = _this$props.privacyUrl,
          termsUrl = _this$props.termsUrl;
      return React.createElement("div", {
        id: "clayer-config",
        "data-base-url": baseUrl,
        "data-client-id": clientId,
        "data-market-id": marketId,
        "data-country-code": countryCode,
        "data-language-code": languageCode,
        "data-cart-url": cartUrl,
        "data-return-url": returnUrl,
        "data-privacy-url": privacyUrl,
        "data-terms-url": termsUrl
      });
    }
  }]);

  return Config;
}(Component);

var Price = /*#__PURE__*/function (_Component) {
  _inherits(Price, _Component);

  function Price() {
    _classCallCheck(this, Price);

    return _possibleConstructorReturn(this, _getPrototypeOf(Price).apply(this, arguments));
  }

  _createClass(Price, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          AmountTag = _this$props.AmountTag,
          skuCode = _this$props.skuCode,
          className = _this$props.className,
          _this$props$AmountPro = _this$props.AmountProps,
          amount = _this$props$AmountPro.amount,
          compare = _this$props$AmountPro.compare;
      return React.createElement(ContainerTag, {
        className: "clayer-price ".concat(className),
        "data-sku-code": skuCode
      }, React.createElement(AmountTag, {
        className: "amount ".concat(amount.className)
      }), React.createElement(AmountTag, {
        className: "compare-at-amount ".concat(compare.className)
      }));
    }
  }]);

  return Price;
}(Component);

Price.defaultProps = {
  ContainerTag: 'div',
  AmountTag: 'span',
  AmountProps: {
    amount: {
      className: ''
    },
    compare: {
      className: ''
    }
  }
};

var VariantSelect = /*#__PURE__*/function (_Component) {
  _inherits(VariantSelect, _Component);

  function VariantSelect() {
    _classCallCheck(this, VariantSelect);

    return _possibleConstructorReturn(this, _getPrototypeOf(VariantSelect).apply(this, arguments));
  }

  _createClass(VariantSelect, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          PriceContainerId = _this$props.PriceContainerId,
          AvailabilityMessageContainerId = _this$props.AvailabilityMessageContainerId,
          AddToBagId = _this$props.AddToBagId,
          promptText = _this$props.promptText,
          skus = _this$props.skus,
          className = _this$props.className,
          AddToBagQuatityId = _this$props.AddToBagQuatityId;
      return React.createElement("select", {
        className: "clayer-variant-select ".concat(className),
        defaultValue: "",
        name: "variant",
        "data-price-container-id": PriceContainerId,
        "data-availability-message-container-id": AvailabilityMessageContainerId,
        "data-add-to-bag-id": AddToBagId,
        "data-add-to-bag-quantity-id": AddToBagQuatityId
      }, React.createElement("option", {
        value: "",
        disabled: true
      }, promptText), skus.map(function (sku, index) {
        return React.createElement("option", {
          key: index,
          className: "clayer-variant ".concat(sku.className),
          value: sku.label,
          "data-sku-code": sku.code,
          "data-sku-name": sku.name,
          "data-sku-reference": sku.reference,
          "data-sku-image-url": sku.imageUrl
        }, sku.label);
      }));
    }
  }]);

  return VariantSelect;
}(Component);

VariantSelect.defaultProps = {
  promptText: 'Select variant'
};

var VariantRadio = /*#__PURE__*/function (_Component) {
  _inherits(VariantRadio, _Component);

  function VariantRadio() {
    _classCallCheck(this, VariantRadio);

    return _possibleConstructorReturn(this, _getPrototypeOf(VariantRadio).apply(this, arguments));
  }

  _createClass(VariantRadio, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          skuCode = _this$props.skuCode,
          skuName = _this$props.skuName,
          skuReference = _this$props.skuReference,
          skuImageUrl = _this$props.skuImageUrl,
          PriceContainerId = _this$props.PriceContainerId,
          AvailabilityMessageContainerId = _this$props.AvailabilityMessageContainerId,
          AddToBagId = _this$props.AddToBagId,
          className = _this$props.className,
          AddToBagQuatityId = _this$props.AddToBagQuatityId;
      return React.createElement("label", null, React.createElement("input", {
        className: "clayer-variant clayer-variant-radio ".concat(className),
        name: "variant",
        type: "radio",
        "data-sku-code": skuCode,
        "data-sku-name": skuName,
        "data-sku-reference": skuReference,
        "data-sku-image-url": skuImageUrl,
        "data-price-container-id": PriceContainerId,
        "data-availability-message-container-id": AvailabilityMessageContainerId,
        "data-add-to-bag-id": AddToBagId,
        "data-add-to-bag-quantity-id": AddToBagQuatityId
      }), text);
    }
  }]);

  return VariantRadio;
}(Component);

VariantRadio.defaultProps = {};

function Template(_ref) {
  var children = _ref.children,
      attrs = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement("template", _extends({}, attrs, {
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
}

var AvailabilityMessageContainer = /*#__PURE__*/function (_Component) {
  _inherits(AvailabilityMessageContainer, _Component);

  function AvailabilityMessageContainer() {
    _classCallCheck(this, AvailabilityMessageContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailabilityMessageContainer).apply(this, arguments));
  }

  _createClass(AvailabilityMessageContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          id = _this$props.id;
      return React.createElement(ContainerTag, {
        className: "clayer-availability-message-container",
        id: id
      });
    }
  }]);

  return AvailabilityMessageContainer;
}(Component);

AvailabilityMessageContainer.defaultProps = {
  ContainerTag: "div"
};

var AvailabilityMessageAvailableTemplate = /*#__PURE__*/function (_Component) {
  _inherits(AvailabilityMessageAvailableTemplate, _Component);

  function AvailabilityMessageAvailableTemplate() {
    _classCallCheck(this, AvailabilityMessageAvailableTemplate);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailabilityMessageAvailableTemplate).apply(this, arguments));
  }

  _createClass(AvailabilityMessageAvailableTemplate, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var availableTemplate = this.props.availableTemplate;
      return React.createElement(Template, {
        id: "clayer-availability-message-available-template"
      }, renderToString(availableTemplate));
    }
  }]);

  return AvailabilityMessageAvailableTemplate;
}(Component);

AvailabilityMessageAvailableTemplate.defaultProps = {};

var AvailabilityMessageUnavailableTemplate = /*#__PURE__*/function (_Component) {
  _inherits(AvailabilityMessageUnavailableTemplate, _Component);

  function AvailabilityMessageUnavailableTemplate() {
    _classCallCheck(this, AvailabilityMessageUnavailableTemplate);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailabilityMessageUnavailableTemplate).apply(this, arguments));
  }

  _createClass(AvailabilityMessageUnavailableTemplate, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var unavailableTemplate = this.props.unavailableTemplate;
      return React.createElement(Template, {
        id: "clayer-availability-message-unavailable-template"
      }, renderToString(unavailableTemplate));
    }
  }]);

  return AvailabilityMessageUnavailableTemplate;
}(Component);

AvailabilityMessageUnavailableTemplate.defaultProps = {};

var AvailabilityMessageMinDays = /*#__PURE__*/function (_Component) {
  _inherits(AvailabilityMessageMinDays, _Component);

  function AvailabilityMessageMinDays() {
    _classCallCheck(this, AvailabilityMessageMinDays);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailabilityMessageMinDays).apply(this, arguments));
  }

  _createClass(AvailabilityMessageMinDays, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var ContainerTag = this.props.ContainerTag;
      return React.createElement(ContainerTag, {
        className: "clayer-availability-message-available-min-days"
      });
    }
  }]);

  return AvailabilityMessageMinDays;
}(Component);

AvailabilityMessageMinDays.defaultProps = {
  ContainerTag: "span"
};

var AvailabilityMessageMaxDays = /*#__PURE__*/function (_Component) {
  _inherits(AvailabilityMessageMaxDays, _Component);

  function AvailabilityMessageMaxDays() {
    _classCallCheck(this, AvailabilityMessageMaxDays);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailabilityMessageMaxDays).apply(this, arguments));
  }

  _createClass(AvailabilityMessageMaxDays, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var ContainerTag = this.props.ContainerTag;
      return React.createElement(ContainerTag, {
        className: "clayer-availability-message-available-max-days"
      });
    }
  }]);

  return AvailabilityMessageMaxDays;
}(Component);

AvailabilityMessageMaxDays.defaultProps = {
  ContainerTag: "span"
};

var AvailabilityMessageShippingMethodName = /*#__PURE__*/function (_Component) {
  _inherits(AvailabilityMessageShippingMethodName, _Component);

  function AvailabilityMessageShippingMethodName() {
    _classCallCheck(this, AvailabilityMessageShippingMethodName);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailabilityMessageShippingMethodName).apply(this, arguments));
  }

  _createClass(AvailabilityMessageShippingMethodName, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var ContainerTag = this.props.ContainerTag;
      return React.createElement(ContainerTag, {
        className: "clayer-availability-message-available-shipping-method-name"
      });
    }
  }]);

  return AvailabilityMessageShippingMethodName;
}(Component);

AvailabilityMessageShippingMethodName.defaultProps = {
  ContainerTag: "span"
};

var AvailabilityMessageShippingMethodPrice = /*#__PURE__*/function (_Component) {
  _inherits(AvailabilityMessageShippingMethodPrice, _Component);

  function AvailabilityMessageShippingMethodPrice() {
    _classCallCheck(this, AvailabilityMessageShippingMethodPrice);

    return _possibleConstructorReturn(this, _getPrototypeOf(AvailabilityMessageShippingMethodPrice).apply(this, arguments));
  }

  _createClass(AvailabilityMessageShippingMethodPrice, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var ContainerTag = this.props.ContainerTag;
      return React.createElement(ContainerTag, {
        className: "clayer-availability-message-available-shipping-method-price"
      });
    }
  }]);

  return AvailabilityMessageShippingMethodPrice;
}(Component);

AvailabilityMessageShippingMethodPrice.defaultProps = {
  ContainerTag: "span"
};

var AddToBag = /*#__PURE__*/function (_Component) {
  _inherits(AddToBag, _Component);

  function AddToBag() {
    _classCallCheck(this, AddToBag);

    return _possibleConstructorReturn(this, _getPrototypeOf(AddToBag).apply(this, arguments));
  }

  _createClass(AddToBag, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          skuCode = _this$props.skuCode,
          skuName = _this$props.skuName,
          skuReference = _this$props.skuReference,
          skuImageUrl = _this$props.skuImageUrl,
          AvailabilityMessageContainerId = _this$props.AvailabilityMessageContainerId,
          className = _this$props.className,
          onClick = _this$props.onClick;
      return React.createElement("a", {
        href: "#",
        className: "clayer-add-to-bag ".concat(className),
        id: id,
        "data-sku-code": skuCode,
        "data-sku-name": skuName,
        "data-sku-reference": skuReference,
        "data-sku-image-url": skuImageUrl,
        "data-availability-message-container-id": AvailabilityMessageContainerId,
        onClick: onClick
      }, text);
    }
  }]);

  return AddToBag;
}(Component);

AddToBag.defaultProps = {
  text: 'Add to bag'
};

var ShoppingBagItemsCount = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagItemsCount, _Component);

  function ShoppingBagItemsCount() {
    _classCallCheck(this, ShoppingBagItemsCount);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagItemsCount).apply(this, arguments));
  }

  _createClass(ShoppingBagItemsCount, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          defaultText = _this$props.defaultText;
      return React.createElement(ContainerTag, {
        className: "clayer-shopping-bag-items-count"
      }, defaultText);
    }
  }]);

  return ShoppingBagItemsCount;
}(Component);

ShoppingBagItemsCount.defaultProps = {
  ContainerTag: "span",
  defaultText: "0"
};

var ShoppingBagSubtotal = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagSubtotal, _Component);

  function ShoppingBagSubtotal() {
    _classCallCheck(this, ShoppingBagSubtotal);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagSubtotal).apply(this, arguments));
  }

  _createClass(ShoppingBagSubtotal, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          defaultText = _this$props.defaultText;
      return React.createElement(ContainerTag, {
        className: "clayer-shopping-bag-subtotal"
      }, defaultText);
    }
  }]);

  return ShoppingBagSubtotal;
}(Component);

ShoppingBagSubtotal.defaultProps = {
  ContainerTag: "div",
  defaultText: "0"
};

var ShoppingBagShipping = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagShipping, _Component);

  function ShoppingBagShipping() {
    _classCallCheck(this, ShoppingBagShipping);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagShipping).apply(this, arguments));
  }

  _createClass(ShoppingBagShipping, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          defaultText = _this$props.defaultText;
      return React.createElement(ContainerTag, {
        className: "clayer-shopping-bag-shipping"
      }, defaultText);
    }
  }]);

  return ShoppingBagShipping;
}(Component);

ShoppingBagShipping.defaultProps = {
  ContainerTag: "div",
  defaultText: "0"
};

var ShoppingBagPayment = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagPayment, _Component);

  function ShoppingBagPayment() {
    _classCallCheck(this, ShoppingBagPayment);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagPayment).apply(this, arguments));
  }

  _createClass(ShoppingBagPayment, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          defaultText = _this$props.defaultText;
      return React.createElement(ContainerTag, {
        className: "clayer-shopping-bag-payment"
      }, defaultText);
    }
  }]);

  return ShoppingBagPayment;
}(Component);

ShoppingBagPayment.defaultProps = {
  ContainerTag: "div",
  defaultText: "0"
};

var ShoppingBagDiscount = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagDiscount, _Component);

  function ShoppingBagDiscount() {
    _classCallCheck(this, ShoppingBagDiscount);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagDiscount).apply(this, arguments));
  }

  _createClass(ShoppingBagDiscount, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          defaultText = _this$props.defaultText;
      return React.createElement(ContainerTag, {
        className: "clayer-shopping-bag-discount"
      }, defaultText);
    }
  }]);

  return ShoppingBagDiscount;
}(Component);

ShoppingBagDiscount.defaultProps = {
  ContainerTag: "div",
  defaultText: "0"
};

var ShoppingBagTaxes = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagTaxes, _Component);

  function ShoppingBagTaxes() {
    _classCallCheck(this, ShoppingBagTaxes);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagTaxes).apply(this, arguments));
  }

  _createClass(ShoppingBagTaxes, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          defaultText = _this$props.defaultText;
      return React.createElement(ContainerTag, {
        className: "clayer-shopping-bag-taxes"
      }, defaultText);
    }
  }]);

  return ShoppingBagTaxes;
}(Component);

ShoppingBagTaxes.defaultProps = {
  ContainerTag: "div",
  defaultText: "0"
};

var ShoppingBagTotal = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagTotal, _Component);

  function ShoppingBagTotal() {
    _classCallCheck(this, ShoppingBagTotal);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagTotal).apply(this, arguments));
  }

  _createClass(ShoppingBagTotal, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          defaultText = _this$props.defaultText;
      return React.createElement(ContainerTag, {
        className: "clayer-shopping-bag-total"
      }, defaultText);
    }
  }]);

  return ShoppingBagTotal;
}(Component);

ShoppingBagTotal.defaultProps = {
  ContainerTag: "div",
  defaultText: "0"
};

var ShoppingBagItems = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagItems, _Component);

  function ShoppingBagItems() {
    _classCallCheck(this, ShoppingBagItems);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagItems).apply(this, arguments));
  }

  _createClass(ShoppingBagItems, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ContainerTag = _this$props.ContainerTag,
          ItemsContainerTag = _this$props.ItemsContainerTag,
          itemTemplate = _this$props.itemTemplate;
      return React.createElement(ContainerTag, {
        id: "clayer-shopping-bag-container"
      }, React.createElement(ItemsContainerTag, {
        id: "clayer-shopping-bag-items-container"
      }), React.createElement(Template, {
        id: "clayer-shopping-bag-item-template"
      }, renderToString(itemTemplate)));
    }
  }]);

  return ShoppingBagItems;
}(Component);

ShoppingBagItems.defaultProps = {
  ContainerTag: "div",
  ItemsContainerTag: "div"
};

var ShoppingBagItemImage = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagItemImage, _Component);

  function ShoppingBagItemImage() {
    _classCallCheck(this, ShoppingBagItemImage);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagItemImage).apply(this, arguments));
  }

  _createClass(ShoppingBagItemImage, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("img", {
        className: "clayer-shopping-bag-item-image"
      });
    }
  }]);

  return ShoppingBagItemImage;
}(Component);

var ShoppingBagItemName = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagItemName, _Component);

  function ShoppingBagItemName() {
    _classCallCheck(this, ShoppingBagItemName);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagItemName).apply(this, arguments));
  }

  _createClass(ShoppingBagItemName, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "clayer-shopping-bag-item-name"
      });
    }
  }]);

  return ShoppingBagItemName;
}(Component);

var ShoppingBagItemUnitAmount = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagItemUnitAmount, _Component);

  function ShoppingBagItemUnitAmount() {
    _classCallCheck(this, ShoppingBagItemUnitAmount);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagItemUnitAmount).apply(this, arguments));
  }

  _createClass(ShoppingBagItemUnitAmount, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "clayer-shopping-bag-item-unit-amount"
      });
    }
  }]);

  return ShoppingBagItemUnitAmount;
}(Component);

var ShoppingBagItemQtyContainer = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagItemQtyContainer, _Component);

  function ShoppingBagItemQtyContainer() {
    _classCallCheck(this, ShoppingBagItemQtyContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagItemQtyContainer).apply(this, arguments));
  }

  _createClass(ShoppingBagItemQtyContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "clayer-shopping-bag-item-qty-container"
      }, React.createElement("span", {
        className: "clayer-shopping-bag-item-availability-message-container"
      }));
    }
  }]);

  return ShoppingBagItemQtyContainer;
}(Component);

var ShoppingBagItemRemove = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagItemRemove, _Component);

  function ShoppingBagItemRemove() {
    _classCallCheck(this, ShoppingBagItemRemove);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagItemRemove).apply(this, arguments));
  }

  _createClass(ShoppingBagItemRemove, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var text = this.props.text;
      return React.createElement("a", {
        href: "#",
        className: "clayer-shopping-bag-item-remove"
      }, text);
    }
  }]);

  return ShoppingBagItemRemove;
}(Component);

ShoppingBagItemRemove.defaultProps = {
  text: "remove"
};

var ShoppingBagItemTotalAmount = /*#__PURE__*/function (_Component) {
  _inherits(ShoppingBagItemTotalAmount, _Component);

  function ShoppingBagItemTotalAmount() {
    _classCallCheck(this, ShoppingBagItemTotalAmount);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShoppingBagItemTotalAmount).apply(this, arguments));
  }

  _createClass(ShoppingBagItemTotalAmount, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "clayer-shopping-bag-item-total-amount"
      });
    }
  }]);

  return ShoppingBagItemTotalAmount;
}(Component);

var Checkout = /*#__PURE__*/function (_Component) {
  _inherits(Checkout, _Component);

  function Checkout() {
    _classCallCheck(this, Checkout);

    return _possibleConstructorReturn(this, _getPrototypeOf(Checkout).apply(this, arguments));
  }

  _createClass(Checkout, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          className = _this$props.className,
          onClick = _this$props.onClick;
      return React.createElement("a", {
        href: "#",
        className: "clayer-shopping-bag-checkout ".concat(className),
        onClick: onClick
      }, text);
    }
  }]);

  return Checkout;
}(Component);

Checkout.defaultProps = {
  text: 'Proceed to checkout'
};
export { AddToBag, AvailabilityMessageAvailableTemplate, AvailabilityMessageContainer, AvailabilityMessageMaxDays, AvailabilityMessageMinDays, AvailabilityMessageShippingMethodName, AvailabilityMessageShippingMethodPrice, AvailabilityMessageUnavailableTemplate, Checkout, Config, Price, ShoppingBagDiscount, ShoppingBagItemImage, ShoppingBagItemName, ShoppingBagItemQtyContainer, ShoppingBagItemRemove, ShoppingBagItemTotalAmount, ShoppingBagItemUnitAmount, ShoppingBagItems, ShoppingBagItemsCount, ShoppingBagPayment, ShoppingBagShipping, ShoppingBagSubtotal, ShoppingBagTaxes, ShoppingBagTotal, VariantRadio, VariantSelect };